import moment from 'moment';

import { getAttachmentUrl } from '~/utils/helper';

import { CompanyFormType, EmployeeFormType } from '../../SharedIndex';
import { RowData } from '../useEmployeeDocuments';

export type EmployeeDocumentsReadDataRow = [
  string,
  string,
  string,
  (
    | {
        name: string;
        hrefLink: string;
      }
    | string
  ),
];

export const readData = (
  empForms: EmployeeFormType[],
  companyForms: CompanyFormType[],
  empId: string,
): EmployeeDocumentsReadDataRow[] =>
  empForms &&
  empForms.map((doc) => {
    const EmployeeFormType = companyForms.find(
      (form) => form.fComFormId === doc.fEmpFormCompFormFK,
    );
    return [
      EmployeeFormType ? EmployeeFormType.fComFormName : '',
      moment(doc.fEmpFormCreatedTime).format('DD.MM.YYYY'),
      moment(doc.fEmpFormUpdatedTime).format('DD.MM.YYYY'),
      doc.fEmpFormAttachmentName
        ? {
            hrefLink: getAttachmentUrl(empId, doc.fEmpFormAttachmentId),
            name: doc.fEmpFormAttachmentName,
          }
        : '',
    ];
  });

export const mapDefaultData = (forms: EmployeeFormType[]): RowData[] =>
  forms.map((doc) => ({
    fEmpFormId: doc.fEmpFormId,
    fEmpFormEmpId: doc.fEmpFormEmpId,
    fEmpFormCompFormFK: doc.fEmpFormCompFormFK,
    fEmpFormCreatedTime: doc.fEmpFormCreatedTime,
    fEmpFormUpdatedTime: doc.fEmpFormUpdatedTime,
    fEmpFormInfo: doc.fEmpFormInfo,
    fEmpFormAttachmentId: doc.fEmpFormAttachmentId,
    fFormAttachment: undefined,
    fEmpFormAttachmentName: doc.fEmpFormAttachmentName,
  }));
